import { commonConstants } from "../constant/common.constants";

export const initialState = {
    secretKey: '',
    errorCode: '',
    successCode: ''
};

const commonReducer = (state = initialState, action) => {
    switch (action.type) {
        case commonConstants.SECRET_KEY_SUCCESS:
            return {
                ...state,
                secretKey: action.getSecretKey.secretKey
            };
        default:
            return state;
    }
};

export default commonReducer;
